import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Routes, Route, useLocation } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { callNavigationInApp } from '../utils/URLSchemeHelper'

import { trackPage } from '../utils/GATracker'

import TrainPositionsApp from '../containers/TrainPositionsApp'
import RouteMapDetail from '../containers/RouteMapDetail'
import DelayCertificateApp from '../containers/DelayCertificateApp'
import AnnouncementDetail from '../containers/AnnouncementDetail'
import StationDetail from '../containers/StationDetail'
import StationViewDetail from '../containers/StationViewDetail'
import SingleTrainModal from '../containers/SingleTrainModal'
import TransferModal from '../containers/TransferModal'
import EntertainmentList from '../containers/EntertainmentList'
import TrainPositionKindModal from '../containers/TrainPositionKindModal'
import RouteMapKindModal from '../containers/RouteMapKindModal'
import TrainSelectModal from '../containers/TrainSelectModal'
import NearbyTrainPositionsApp from '../containers/NearbyTrainPositionsApp'

// Viewのみ
import TermsDetail from '../components/terms/TermsDetail'
import ContactDetail from '../components/contact/ContactDetail'

import URLMetaData from '../data/URLMetadata'

// ブラウザで確認する時は、location を書き換えないようにする　
const LOCATION_CHANGE_DISABLED = process.env.LOCATION_CHANGE_DISABLED === 'true'

const App = () => {
  const location = useLocation()
  const intl = useIntl()

  useEffect(() => {
    callAppNavigationURLIfNeeded(location.pathname, intl)
    trackPage(location.pathname + location.search)
  }, [location, intl])

  return (
    <Routes>
      <Route path="/lines/:lineName/trains" element={<TrainPositionsApp />} />
      <Route path="/lines/:lineName/trains/select" element={<TrainSelectModal />} />
      <Route path="/lines/:lineName/trains/:trainNumber" element={<SingleTrainModal />} />
      <Route path="/lines/:lineName/route_map" element={<RouteMapDetail />} />
      <Route path="/stations/:stationId" element={<StationDetail />} />
      <Route path="/stations/:stationId/station_view" element={<StationViewDetail />} />
      <Route path="/stations/:stationId/transfers" element={<TransferModal />} />
      <Route path="/stations/:stationId/trains" element={<NearbyTrainPositionsApp />} />
      <Route path="/trains/kinds" element={<TrainPositionKindModal />} />
      <Route path="/route_map/kinds" element={<RouteMapKindModal />} />
      <Route path="/delay_certificates" element={<DelayCertificateApp />} />
      <Route path="/delay_certificates/:certificateId" element={<DelayCertificateApp />} />
      <Route path="/announcement" element={<AnnouncementDetail />} />
      <Route path="/terms" element={<TermsDetail />} />
      <Route path="/contacts" element={<ContactDetail />} />
      <Route path="/entertainment" element={<EntertainmentList />} />
    </Routes>
  )
}

function callAppNavigationURLIfNeeded(location, intl) {
  if (!URLMetaData.isNeededToNotifyURLToApp(location)) return

  const locale = intl.locale
  const title = URLMetaData.getTitle(location, locale)
  if (title === undefined) {
    alert(`DEBUG: ${location} で ${locale}に対応する翻訳が存在しないもしくはURLが網羅されていない`)
  }
  const isLocationButtonShow = URLMetaData.getIsCoordAcceptable(location)
  const isReloadButtonShow = URLMetaData.getIsReloadable(location)
  const query = `title=${title}&location=${isLocationButtonShow}&reloadable=${isReloadButtonShow}`

  if(LOCATION_CHANGE_DISABLED) {
    console.log('URL変更通知', query)
  } else {
    callNavigationInApp(query)
  }
}

export default App
